import { render, staticRenderFns } from "./StructureEditorDraft.vue?vue&type=template&id=2ce82e05&scoped=true&"
import script from "./StructureEditorDraft.vue?vue&type=script&lang=js&"
export * from "./StructureEditorDraft.vue?vue&type=script&lang=js&"
import style0 from "./StructureEditorDraft.vue?vue&type=style&index=0&id=2ce82e05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce82e05",
  null
  
)

export default component.exports